import React from 'react'
import styles from './unknown-error.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import Footer from '../../../../footer/footer'
import Button from 'pobble-components/dist/button'
import duck from '../../../../images/duck-confused.gif'

const UnknownError = ({ classes }) => (
  <Wrapper>
    <Container primary img={duck} imgClassName={classes.img}>
      <Description noBorder title="We're sorry. That has us confused to.">
        <p>
          We have logged the error and now looking into it. If this continues to
          happen please contact{' '}
          <a href="mailto:hello@pobble.com">hello@pobble.com</a>
        </p>
      </Description>
      <Footer dense>
        <Button href="/" wide tall>
          Take me back home
        </Button>
      </Footer>
    </Container>
  </Wrapper>
)

export default injectSheet(styles)(UnknownError)
